import { action } from 'typesafe-actions';
import localStorage from 'local-storage';
import * as Sentry from '@sentry/browser';
import { IPagination } from 'app/types/common';
import { UsersActionTypes as types } from './types';

/* ********************************* APP ACTIONS ********************************* */

export const createUser = (data): any => action(types.CREATE_USER_REQUESTED, data);

export const updateUser = (data): any => action(types.UPDATE_USER_REQUESTED, data);

export const deleteUser = (userId): any => action(types.UPDATE_USER_REQUESTED, userId);

export const getUser = (userId, redirectDashboard = false): any => action(types.GET_USER_REQUESTED, { userId, redirectDashboard });

export const getAllUsers = (
  pagination: IPagination = undefined,
  compile = true,
): any => action(types.GET_ALL_USERS_REQUESTED, { pagination, compile });

export const selectUser = (userId): any => action(types.SELECT_USER_REQUESTED, {
  currentUserId: userId,
});

/* ********************************* SAGA ACTIONS ********************************* */
export const sagaActions = {
  createUserPending: (payload): any => action(types.CREATE_USER_PENDING, payload),
  createUserSuccess: (response): any => action(types.CREATE_USER_SUCCESS, {
    usersById: response.entities.users,
    currentUserId: response.result,
  }),
  updateUserPending: (payload): any => action(types.UPDATE_USER_PENDING, payload),
  updateUserSuccess: (response): any => action(types.UPDATE_USER_SUCCESS, {
    usersById: response.entities.users,
    currentUserId: response.result,
  }),
  updateUserFailed: (error): any => action(types.UPDATE_USER_FAIL, { backendErrors: error }),
  deleteUserPending: (): any => action(types.UPDATE_USER_PENDING, {}),
  deleteUserSuccess: (response, userId): any => {
    localStorage.set(userId, { currentUserId: null });

    return action(types.DELETE_USER_SUCCESS, {
      currentUserId: response,
    });
  },
  getUserPending: (): any => action(types.GET_USER_PENDING, {}),
  getUserSuccess: (response): any => {
    Sentry.setUser({
      username: `${response.firstName} ${response.lastName}`,
      email: response.email,
      id: response.id,
    });
    return action(types.GET_USER_SUCCESS, {
      usersById: response.entities.users,
      currentUserId: response.result,
    });
  },
  getUserFailed: (error): any => action(types.GET_USER_FAIL, { backendErrors: error }),
  deleteUserFailed: (error): any => action(types.UPDATE_USER_FAIL, { backendErrors: error }),
  getAllUsersPending: (pagination): any => action(types.GET_ALL_USERS_PENDING, { pagination }),
  getAllUsersSuccess: (response, meta): any => action(types.GET_ALL_USERS_SUCCESS, {
    usersById: response.entities.users,
    userIds: response.result,
    meta,
  }),
  getAllUsersFailed: (error): any => action(types.GET_ALL_USERS_FAIL, { backendErrors: error }),
  createUserFailed: (error): any => action(types.CREATE_USER_FAIL, { backendErrors: error }),
};

export default null;
